import { Spinner } from '@frontend/components/common';

import WizardNavigationHeader from '../components/wizard-navigation-header/wizard-navigation-header.component';
import useWizardInitialisation from './wizard-initialisation.controller';

const ID = 'wizard-initialisation';

const WizardInitialisation = () => {
    useWizardInitialisation();
    return (
        <div
            className='bg-background-default flex h-dvh flex-col'
            id={ID}>
            <WizardNavigationHeader title={'...'} />
            <div className='my-6 flex w-full items-center justify-center'>
                <Spinner />
            </div>
        </div>
    );
};

export default WizardInitialisation;
